var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgotPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 382,
    height: 290,
    viewBox: "0 0 382 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1779",
    x: 72,
    y: 215,
    width: 176,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1772",
    x: 25,
    y: 113,
    width: 271,
    height: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384",
    transform: "translate(-180 -342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M84.483,120.028c22.559-24.346,57.809-37.3,91.16-40.51a277.98,277.98,0,0,1,29.417-1.185c96.835.979,125.164,40.636,118.983,59.73s-23.694,30.845,1.546,57.283,53.568,66.1,39.146,105.753S289.177,355.431,205.7,356.64,61.354,361.319,43.326,324.6s21.394-61.915,26.922-93.381c3.428-19.51-5.379-39.177-6.025-58.638C63.527,151.559,71.513,134.026,84.483,120.028Z",
    transform: "translate(141.359 263.684)",
    fill: "#fff7e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3110",
    "data-name": "Group 3110",
    transform: "translate(275.712 570.858)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -95.71, -228.86)",
    filter: "url(#Rectangle_1779)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1779-2",
    "data-name": "Rectangle 1779",
    width: 128,
    height: 27,
    rx: 13.5,
    transform: "translate(96 229)",
    fill: "#393939"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5718",
    "data-name": "Group 5718",
    transform: "translate(229 469.396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -49, -127.4)",
    filter: "url(#Rectangle_1772)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1772-2",
    "data-name": "Rectangle 1772",
    width: 223,
    height: 72,
    rx: 5,
    transform: "translate(49 127)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5717",
    "data-name": "Group 5717",
    transform: "translate(102.397 28.375)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(-0.397 0.228)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 7,
    cy: 7.5,
    rx: 7,
    ry: 7.5,
    transform: "translate(54.603 0.228)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 7,
    cy: 7.5,
    rx: 7,
    ry: 7.5,
    transform: "translate(27.603 0.228)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(81.603 0.228)",
    fill: "#feba26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5921",
    "data-name": "Group 5921",
    transform: "translate(24.674 17.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13320",
    "data-name": "Path 13320",
    d: "M360.809,437.5v21.633c-.136.018-.126.13-.154.209a4.737,4.737,0,0,1-4.887,3.242q-20.866,0-41.732,0c-3.006,0-5.037-1.841-5.038-4.554q0-10.107,0-20.213v-.421a1.726,1.726,0,0,1,.184.074q10.525,6.331,21.048,12.664a8.5,8.5,0,0,0,9.337.009q10.442-6.275,20.883-12.55C360.547,437.533,360.631,437.335,360.809,437.5Z",
    transform: "translate(-308.994 -425.573)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13321",
    "data-name": "Path 13321",
    d: "M360.788,361.718c-.027.014-.074.025-.079.044a5.07,5.07,0,0,1-2.681,3.052q-10.043,6.007-20.049,12.065a5.251,5.251,0,0,1-6.17.011l-20.587-12.408a3.958,3.958,0,0,1-2.045-4.778,4.762,4.762,0,0,1,4.568-3.088c.489-.011.978,0,1.467,0H355.58c2.767,0,4.44,1.173,5.132,3.593.006.021.049.033.075.049Z",
    transform: "translate(-308.972 -356.611)",
    fill: "#feba26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6381",
    "data-name": "Group 6381",
    transform: "translate(-56.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5956",
    "data-name": "Group 5956",
    transform: "translate(280.62 342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13369",
    "data-name": "Path 13369",
    d: "M323.234,403.91c-1.153-.346-2.325-.64-3.457-1.046A16.626,16.626,0,0,1,308.7,387.533c-.089-11.844-.113-23.69,0-35.534a16.762,16.762,0,0,1,16.275-16.4c1.546-.049,3.1-.078,4.641,0,.877.045,1.01-.273,1-1.052-.035-4.463.023-8.928-.025-13.391a24.991,24.991,0,0,1,20.313-24.738,25.408,25.408,0,0,1,29.133,16.8,24.946,24.946,0,0,1,1.209,7.982c.009,4.464.03,8.928-.021,13.391-.01.866.267,1.006,1.048,1a37.689,37.689,0,0,1,7.884.39c2.726.57,4.252,2.594,3.756,5.131-.448,2.3-2.64,3.615-5.235,3.142a16.272,16.272,0,0,0-2.934-.252q-29.756.01-59.512.006c-5.6,0-9.132,3.538-9.134,9.153q0,16.607,0,33.214c0,5.537,3.553,9.086,9.093,9.088,17.129,0,19.52,0,36.649,0,2.3,0,3.917,1.057,4.507,2.917a4.153,4.153,0,0,1-2.833,5.312c-.134.04-.274.037-.314.206Zm32.6-68.329c5.378,0,10.755-.013,16.133.016.69,0,.869-.179.864-.866-.032-4.461-.013-8.921-.017-13.382a16.882,16.882,0,0,0-33.762-.3c-.015,4.531.022,9.062-.026,13.593-.009.821.236.957.991.953C345.291,335.565,350.564,335.581,355.836,335.581Z",
    transform: "translate(-308.626 -295.91)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13370",
    "data-name": "Path 13370",
    d: "M623.137,681.989c-.166-.322-.528-.287-.794-.422a4.188,4.188,0,0,1,2.178-7.933,4.211,4.211,0,0,1,3.818,3.8,4.136,4.136,0,0,1-3.005,4.349c-.133.04-.272.037-.313.2Z",
    transform: "translate(-553.672 -573.989)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13371",
    "data-name": "Path 13371",
    d: "M589.893,537.339a11.773,11.773,0,0,1,2.489-8.305,10.7,10.7,0,0,1,3.906-3.071,6.692,6.692,0,0,0,4.093-4.687,6.469,6.469,0,1,0-12.628-2.811,12.7,12.7,0,0,0-.181,1.556,4.184,4.184,0,0,1-8.362-.261,14.86,14.86,0,1,1,21.958,13.075c-.555.29-1.115.573-1.643.907a2.777,2.777,0,0,0-1.259,2.5c-.012,1.151.019,2.3-.012,3.453a4.179,4.179,0,0,1-8.358.058C589.867,539.019,589.893,538.285,589.893,537.339Z",
    transform: "translate(-523.56 -449.486)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13372",
    "data-name": "Path 13372",
    d: "M386.565,565.184a4.182,4.182,0,1,1,4.2-4.175A4.185,4.185,0,0,1,386.565,565.184Z",
    transform: "translate(-362.92 -487.998)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13373",
    "data-name": "Path 13373",
    d: "M450.76,561a4.181,4.181,0,1,1-4.188-4.182A4.214,4.214,0,0,1,450.76,561Z",
    transform: "translate(-407.078 -487.998)",
    fill: "#feba26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5957",
    "data-name": "Group 5957",
    transform: "translate(394.156 370.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13375",
    "data-name": "Path 13375",
    d: "M17.741,6.865V0H0V29.22H17.741V22.355H12.988V18.042h4.753V11.177H12.988V6.865Z",
    transform: "translate(34.726 29.719) rotate(90)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    d: "M.389,0h9.34a.389.389,0,0,1,.389.389V74.862a5.059,5.059,0,0,1-5.059,5.059h0A5.059,5.059,0,0,1,0,74.862V.389A.389.389,0,0,1,.389,0Z",
    transform: "translate(79.921 20.503) rotate(90)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 26,
    cy: 25.5,
    rx: 26,
    ry: 25.5,
    transform: "translate(66.465)",
    fill: "#feba26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13376",
    "data-name": "Path 13376",
    d: "M2.193.127Q1.539.4.906.716A1.658,1.658,0,0,0,.155,2.9l.014.031A1.678,1.678,0,0,0,2.453,3.7q.5-.245,1.009-.461a1.671,1.671,0,0,0,.933-2.126L4.381,1.08A1.664,1.664,0,0,0,2.193.127Z",
    transform: "translate(112.822 15.484) rotate(90)",
    fill: "#fedc92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13377",
    "data-name": "Path 13377",
    d: "M3.4,0Q2.439,0,1.506.089A1.662,1.662,0,0,0,.065,2.2l.009.032a1.671,1.671,0,0,0,1.761,1.2,18.153,18.153,0,0,1,5.131.284,18.284,18.284,0,0,1,14.6,16.577A18.2,18.2,0,0,1,13.232,36.9a1.638,1.638,0,0,0-.492,2.31l.066.1a1.645,1.645,0,0,0,2.206.451A21.576,21.576,0,0,0,3.4,0Z",
    transform: "translate(113.949 22.164) rotate(90)",
    fill: "#fedc92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 4.573,
    cy: 4.573,
    rx: 4.573,
    ry: 4.573,
    transform: "translate(94.081 20.988)",
    fill: "#fedc92"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3108",
    "data-name": "Group 3108",
    transform: "translate(487 506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M661.985,266.349c.7-42.23-18.162-59.554-18.162-59.554-4.6,23.3,2.752,48.245,6.847,59.554Z",
    transform: "translate(-630.454 -197.848)",
    fill: "#7fd2a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5179",
    "data-name": "Path 5179",
    d: "M666.226,262.96c20.565-28.029,17.248-50.02,17.248-50.02-17.765,14.81-26.951,39.4-30.147,49.561l.524.459Z",
    transform: "translate(-624.595 -194.542)",
    fill: "#7fd2a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5180",
    "data-name": "Path 5180",
    d: "M675.54,256.58c17.536-17.743,21.147-32.072,21.147-32.072-21.665,8.738-32.3,22.914-37.8,32.072Z",
    transform: "translate(-621.686 -188.208)",
    fill: "#00a651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5181",
    "data-name": "Path 5181",
    d: "M657.711,259.229c-6.712-30.359-23.086-39.524-23.086-39.524.354,15.713,7.526,30.721,12.666,39.524Z",
    transform: "translate(-634.625 -190.84)",
    fill: "#00a651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M667.153,269.529c8.9-49.451-5.318-68.5-5.318-68.5-16.961,17.2-10.533,57.886-8.5,68.5Z",
    transform: "translate(-626.097 -201.028)",
    fill: "#00a651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5183",
    "data-name": "Path 5183",
    d: "M659.877,264.622c-1.3-18.245-2.181-36.659-2.565-54.881a.388.388,0,0,0-.388-.38h-.008a.389.389,0,0,0-.38.4c.383,18.216,1.268,36.623,2.563,54.864Z",
    transform: "translate(-622.749 -196.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M655.075,263.069h.813a188.525,188.525,0,0,1-5.263-21.879l-5.692-28.7a.382.382,0,0,0-.456-.306.388.388,0,0,0-.3.456l5.692,28.7A191.758,191.758,0,0,0,655.075,263.069Z",
    transform: "translate(-629.466 -194.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5185",
    "data-name": "Path 5185",
    d: "M650.786,255.933c-4.693-9.992-8.98-20.228-12.753-30.563a.388.388,0,0,0-.728.267c3.739,10.243,7.982,20.388,12.624,30.3Z",
    transform: "translate(-633.161 -187.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5186",
    "data-name": "Path 5186",
    d: "M660.478,259.636c.729-1.381,1.424-2.79,2.026-4.234a75.654,75.654,0,0,0,2.794-8.569c.475-1.682.965-3.419,1.519-5.1a127.077,127.077,0,0,1,4.822-11.894c1.576-3.539,3.207-7.2,4.5-10.921a.389.389,0,0,0-.734-.256c-1.281,3.7-2.9,7.337-4.475,10.86a128.261,128.261,0,0,0-4.85,11.968c-.557,1.7-1.05,3.443-1.528,5.132a75.532,75.532,0,0,1-2.763,8.48c-.644,1.545-1.4,3.053-2.191,4.533Z",
    transform: "translate(-621.143 -191.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5187",
    "data-name": "Path 5187",
    d: "M662.283,254.214c1.5-1.683,3.13-3.264,4.741-4.8L688.565,228.9a.388.388,0,0,0-.535-.563l-21.542,20.511c-1.786,1.7-3.593,3.458-5.235,5.362Z",
    transform: "translate(-620.381 -186.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5188",
    "data-name": "Path 5188",
    d: "M642.81,249.872l5.123,31.711a9.285,9.285,0,0,0,9.165,7.8h15.611a9.285,9.285,0,0,0,9.165-7.8L687,249.872Z",
    transform: "translate(-630.29 -174.385)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5189",
    "data-name": "Path 5189",
    d: "M687,249.872H642.81l.709,4.394h34.066l-4.414,27.317a9.284,9.284,0,0,1-9.165,7.8h8.7a9.284,9.284,0,0,0,9.165-7.8l4.414-27.317h0Z",
    transform: "translate(-630.29 -174.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5190",
    "data-name": "Path 5190",
    d: "M689.306,243.992H644.133a4.631,4.631,0,0,0-4.617,4.617h0a4.63,4.63,0,0,0,4.617,4.617h45.173a4.63,4.63,0,0,0,4.617-4.617h0A4.631,4.631,0,0,0,689.306,243.992Z",
    transform: "translate(-631.928 -177.519)",
    fill: "#393939"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPass);
export default __webpack_public_path__ + "static/media/forgot_pass.4bb70b10a631b6c9e3d10692c3226310.svg";
export { ForwardRef as ReactComponent };